import { EChannel } from './entryRecords';
import { EAgentLevel } from '../../common';

export interface ISettlementOrderParams{
  page: number;
  size: number;
  /** 收款订单号 */
  orderNo?: string;
  /** 收款订单号（支付平台） */
  tpOrderNo?: string;
  /** 结算订单号	 */
  settleNo?: string;
  /** 结算订单号（支付平台）	 */
  tpSettleNo?: string;
  /** 支付通道 LIANLIAN：连连 YEEPAY：易宝支付 */
  channel?: EChannel;
  /** 结算类型 SETTLE_TO_ACCOUNT：结算入户  */
  settleType?: ESettleType;
  /** 收款企业主键 */
  companyId?: number;
  /** 收款企业 */
  companyName?: string;
  /** 收款企业所属代理商主键 */
  agentId?: number;
  /** 收款企业所属代理商 */
  agentName?: string;
  /** 结算时间开始 */
  settleTimeStart?: string;
  /** 结算时间结束 */
  settleTimeEnd?: string;
  /** 是否是门店订单。默认：false */
  fromStore?: boolean;
}

export interface ISettlementOrderInfo{
  /**  */
  id: number;
  /** 收款订单号 */
  orderNo: string;
  /** 收款订单号（支付平台） */
  tpOrderNo: string;
  /** 结算订单号	 */
  settleNo: string;
  /** 结算订单号（支付平台）	 */
  tpSettleNo: string;
  /** 支付通道 LIANLIAN：连连 YEEPAY：易宝支付 */
  channel: EChannel;
  /** 结算类型 SETTLE_TO_ACCOUNT：结算入户  */
  settleType: ESettleType;
  /** 结算金额 */
  settleAmt: number;
  /** 收款企业主键 */
  companyId: number;
  /** 收款企业 */
  companyName: string;
  /** 收款企业所属代理商主键 */
  agentId: number;
  /** 收款企业所属代理商 */
  agentName: string;
  /** 结算时间 */
  settleTime: string;
  /** 收款企业所属代理商等级 0：特代 1：一代 2：二代  */
  agentLevelType: EAgentLevel;
}

export enum ESettleType {
  /** 结算入户 */
  SETTLE_TO_ACCOUNT = 'SETTLE_TO_ACCOUNT',
}

export const settleTypeConfig = { [ESettleType.SETTLE_TO_ACCOUNT]: '结算入户' };